import { SOService } from '../../Services/SO/so.service';
import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { GetAllSOs, ESOActions, SetSOError, AddSO,InActivatePs, SetSOSuccess, EditSO, AddDispatchOrder, GetSOCode, GetAllDOs, GetDOdetails, AddPackSlips, GetAllPackSlips, EditpackSlips, GetDONumber, AddDO, GetSOById, GetInActiveStatus, CloseSO, GetRPsBasedOnMonth, GetForcastSales, AddForcastSales, EditForcastSales, GetDOsByPS, GetDosByFormulaId, GetSOsByCustomerId, cancelDo } from '../actions/so.action';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';


@Injectable()
export class SOEffects {

  getallSOs$ = createEffect(() => this.actions$.pipe(
    ofType<GetAllSOs>(ESOActions.GetAllSOs),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getAllSOs(payload)
      .pipe(map((result: any) => ({ type: '[SO] Set All SO Details', payload: result })),
        catchError((err) => of({ type: 'Set SO Error', payload: err, from: 'getSO' }))
      )
    )
  ));


  getSObyId$ = createEffect(() => this.actions$.pipe(
    ofType<GetSOById>(ESOActions.GetSOById),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getSOById(payload)
      .pipe(map((result: any) => ({ type: '[SO] Set SO By Id Success', payload: result })),
        catchError((err) => of({ type: '[SO] Set SO By Id Error', payload: err, from: 'getSOById' }))
      )
    )
  ));


  getaddSO$ = createEffect(() => this.actions$.pipe(
    ofType<AddSO>(ESOActions.AddSO),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.addSO(payload)
      .pipe(map((result: any) => ({ type: 'Set SO Success', payload: result, from: 'addSO' })),
        catchError((err) => of({ type: 'Set SO Error', payload: err, from: 'addSO' }))
      )
    )
  ));


  getedtSO$ = createEffect(() => this.actions$.pipe(
    ofType<EditSO>(ESOActions.EditSO),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.editSO(payload)
      .pipe(map((result: any) => ({ type: 'Set SO Success', payload: result, from: 'editSO' })),
        catchError((err) => of({ type: 'Set SO Error', payload: err, from: 'editSO' }))
      )
    )
  ));


  addDispatchOrder$ = createEffect(() => this.actions$.pipe(
    ofType<AddDispatchOrder>(ESOActions.AddDispatchOrder),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.addDispatchOrder(payload)
      .pipe(map((result: any) => ({ type: 'Set SO Success', payload: result, from: 'addDispatchOrder' })),
        catchError((err) => of({ type: 'Set SO Error', payload: err, from: 'addDispatchOrder' }))
      )
    )
  ));


  getSOCode$ = createEffect(() => this.actions$.pipe(
    ofType<GetSOCode>(ESOActions.GetSOCode),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getSOCode(payload)
      .pipe(map((result: any) => ({ type: '[SO] Get SO Code Success', payload: result })),
        catchError((err) => of({ type: 'Set SO Error', payload: err, from: 'getSOCode' }))
      )
    )
  ));

  inActivateSO$ = createEffect(() => this.actions$.pipe(
    ofType<GetInActiveStatus>(ESOActions.GetInActiveStatus),
    map(action => action),
    mergeMap((action: any) => this.soService.inActivateSO(action.payload, action.param)
      .pipe(map((result: any) => ({ type: '[SO] InActive Status Success', payload: result })),
        catchError((err) => of({ type: '[SO] InActive Status Error', payload: err, from: 'InactiveSO' }))
      )
    )
  ));

  closeSO$ = createEffect(() => this.actions$.pipe(
    ofType<CloseSO>(ESOActions.CloseSO),
    map(action => action),
    mergeMap((action: any) => this.soService.closeSO(action.payload, action.param)
      .pipe(map((result: any) => ({ type: '[SO] Close SO Success', payload: result })),
        catchError((err) => of({ type: '[] Close SO Error', payload: err, from: 'CloseSO' }))
      )
    )
  ));
  // dispatch orders


  getDONumber$ = createEffect(() => this.actions$.pipe(
    ofType<GetDONumber>(ESOActions.GetDONumber),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getDONumber(payload)
      .pipe(map((result: any) => ({ type: '[DispatchOrders] Set Dispath Orders InternalCode Success', payload: result })),
        catchError((err) => of({ type: '[DispatchOrders] Set Dispath Orders InternalCode Error', payload: err, from: 'getDONumber' }))
      )
    )
  ));


  addDO$ = createEffect(() => this.actions$.pipe(
    ofType<AddDO>(ESOActions.AddDO),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.addDO(payload)
      .pipe(map((result: any) => ({ type: '[DispatchOrders] Set Add Dispatch Order Success', payload: result })),
        catchError((err) => of({ type: '[DispatchOrders] Set Add Dispatch Order Error', payload: err, from: 'addDO' }))
      )
    )
  ));


  getAllDOs$ = createEffect(() => this.actions$.pipe(
    ofType<GetAllDOs>(ESOActions.GetAllDOs),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getAllDOs(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Get All DOs success', payload: result })),
        catchError((err) => of({ type: '[] Get All DOs Error', payload: err, from: 'getAllDOs' }))
      )
    )
  ));

  getDOsByPS$ = createEffect(() => this.actions$.pipe(
    ofType<GetDOsByPS>(ESOActions.GetDOsByPS),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getDOsByPS(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Get DOs By PS Success', payload: result })),
        catchError((err) => of({ type: '[] Get DOs By PS Error', payload: err, from: 'getDOsByPS' }))
      )
    )
  ));

  getDOdetails$ = createEffect(() => this.actions$.pipe(
    ofType<GetDOdetails>(ESOActions.GetDOdetails),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getDOdetails(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Get DO details success', payload: result })),
        catchError((err) => of({ type: '[] Get DO details Error', payload: err, from: 'getDOdetails' }))
      )
    )

  ));


  addPackslips$ = createEffect(() => this.actions$.pipe(
    ofType<AddPackSlips>(ESOActions.AddPackSlips),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.addPackslips(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Add Pack Slips success', payload: result })),
        catchError((err) => of({ type: '[] Add Pack Slips Error', payload: err, from: 'addPackSlips' }))
      )
    )

  ));

  getAllPackslips$ = createEffect(() => this.actions$.pipe(
    ofType<GetAllPackSlips>(ESOActions.GetAllPackSlips),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getAllPackslips(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Get All PackSlips Success', payload: result })),
        catchError((err) => of({ type: '[] Get All PackSlipsError', payload: err, from: 'getAllPackSlips' }))
      )
    )

  ));

  editpackSlips$ = createEffect(() => this.actions$.pipe(
    ofType<EditpackSlips>(ESOActions.EditpackSlips),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.editPackslips(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Edit Pack Slips Success', payload: result })),
        catchError((err) => of({ type: '[] Edit Pack Slips Error', payload: err, from: 'editPackSlips' }))
      )
    )
  ));

  getRPsBasedOnMonth$ = createEffect(() => this.actions$.pipe(
    ofType<GetRPsBasedOnMonth>(ESOActions.GetRPsBasedOnMonth),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getRpsbasedOnMonth(payload)
      .pipe(map((result: any) => ({ type: '[RPs] Get RPs Based on Month Success', payload: result })),
        catchError((err) => of({ type: '[] Get RPs Based on Month Error', payload: err, from: 'getRpsBasedOnMonth' }))
      )
    )

  ));

  getForcastsales$ = createEffect(() => this.actions$.pipe(
    ofType<GetForcastSales>(ESOActions.GetForcastSales),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getForcastSales(payload)
      .pipe(map((result: any) => ({ type: '[Forecast] Get Forcast Sales Success', payload: result })),
        catchError((err) => of({ type: '[] Get Forcast Sales Error', payload: err, from: 'getForcastsales' }))
      )
    )

  ));

  addForcastsales$ = createEffect(() => this.actions$.pipe(
    ofType<AddForcastSales>(ESOActions.AddForcastSales),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.addForcastSales(payload)
      .pipe(map((result: any) => ({ type: '[Forecast] Get Add Forcast Sales Success', payload: result })),
        catchError((err) => of({ type: '[] Get Add Forcast Sales Error', payload: err, from: 'AddForcastsales' }))
      )
    )
    )
  );

  editForcastsales$ = createEffect(() => this.actions$.pipe(
    ofType<EditForcastSales>(ESOActions.EditForcastSales),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.editForcastSales(payload)
      .pipe(map((result: any) => ({ type: '[Forecast] Get Edit Forcast Sales Success', payload: result })),
        catchError((err) => of({ type: '[] Get Edit Forcast Sales Error', payload: err, from: 'EditForcastsales' }))
      )
    )

  ));

  getDosByFormulaId$ = createEffect(() => this.actions$.pipe(
    ofType<GetDosByFormulaId>(ESOActions.GetDosByFormulaId),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.getDosByFormulaId(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Get Dos By Formula Id Success', payload: result })),
        catchError((err) => of({ type: '[] Get Dos By Formula Id Error', payload: err, from: 'GetDosByFormulaId' }))
      )
    )
  ));

  inActivatePs$ = createEffect(() => this.actions$.pipe(
    ofType<InActivatePs>(ESOActions.InActivatePs),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.InActivatePs(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] InActivate Ps Success', payload: result })),
        catchError((err) => of({ type: '[] InActivate Ps Error', payload: err, from: 'InActivatePs' }))
      )
    )
  ));

  getSOsByCustomerId$ = createEffect(() => this.actions$.pipe(
    ofType<GetSOsByCustomerId>(ESOActions.GetSOsByCustomerId),
    map(action => action.param),
    mergeMap((payload: any) => this.soService.getSOsByCustomerId(payload)
      .pipe(map((result: any) => ({ type: '[SO] Get SOs By CustomerId Success', payload: result })),
        catchError((err) => of({ type: '[] Get SOs By CustomerId Error', payload: err, from: 'getSOsByCustomerId' }))
      )
    )
  ));

  cancelDo$ = createEffect(() => this.actions$.pipe(
    ofType<cancelDo>(ESOActions.cancelDo),
    map(action => action.payload),
    mergeMap((payload: any) => this.soService.cancelDo(payload)
      .pipe(map((result: any) => ({ type: '[dispatchOrders] Cancel Do Success', payload: result })),
        catchError((err) => of({ type: '[] cancel Do Error', payload: err, from: 'cancelDo' }))
      )
    )
  ));


  constructor(private actions$: Actions,
    private store: Store<IAppState>,
    private soService: SOService
  ) { }
}
